<template>
    <div class="mt-4 flex gap-10 text-xs text-gray-90">
        <!-- APD -->
        <div class="flex items-center gap-1" v-if="applicationDate">
            <span>{{ $t('date') }}</span>
            {{applicationDate}}
        </div>

        <!-- Owner -->
        <div class="flex items-center gap-1" v-if="showOrgInfoName">
            <span>{{ $t('owner') }}</span>
            <SolutionOrgIcon :org-info="OrgInfo" />
            <a v-if="companyHref" :href="companyHref" target="blank" class="hover:underline">
                <span class="max-w-[200px] truncate" :title="showOrgInfoName" v-html="showOrgInfoName"/>
            </a>
            <span v-else class="max-w-[320px] truncate" :title="showOrgInfoName" v-html="showOrgInfoName"/>
            <OrgPopover v-if="showOrgInfoCounts" :counts="showOrgInfoCounts" :orgs="profile.org_info"></OrgPopover>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IBaseSolution } from '@/types';
import SolutionOrgIcon from './SolutionOrgIcon.vue'
import OrgPopover from './OrgPopover.vue'
import { computed } from 'vue';
import { get } from 'lodash'
import { generateCompanyHref } from '@eureka/utils/company';

const props = defineProps<{
    profile: IBaseSolution
}>()

const showOrgInfoName = computed(() => {
    return get(props.profile, 'org_info[0].display_name', '')
})

const OrgInfo = computed(() => {
    return get(props.profile, 'org_info[0]')
})

const showOrgInfoCounts = computed(() => {
    return get(props.profile, 'org_info', []).length ? get(props.profile, 'org_info', []).length - 1 : 0
})

const applicationDate = computed(() => {
    return get(props.profile, 'apd', '')
})

const companyHref = computed(() => {
    const orgId = get(props.profile, 'org_info[0].id', '')
    return generateCompanyHref(orgId)
})

</script>
